export default __webpack_public_path__ + "static/media/check-lend.0511e4d8.svg";